export default "__VITE_ASSET__916d1f2b__"